import React, { useState } from 'react';
import Button from '../ui/button';
import { ShoppingCart, Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import ItemCustomization from './ItemCustomization';
import { useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
//import { clear } from '@testing-library/user-event/dist/clear';
//import { isCancel } from 'axios';

export default function Cart({ cart, onUpdateCart, onRemoveFromCart, onUpdateCartCount, onCheckout, cartTotal, cartCount, isCancel, setIsCancel, clearCart, cancelSource, setCancelSource }) {
  const [isOpen, setIsOpen] = useState(false);
  const [updateItem, setUpdateItem] = useState(null);
  const MenuItem = useSelector((state) => state.menu.menu_items);
  // const [isCancel, setIsCancel] = useState(false);
  // Handle Cancel Action
  const onCancel = () => {
    setIsCancel(true);
  };
  const handleCustomizationComplete = (item, customizations, qty, instructions) => {
    //const customizationPrice = customizations.reduce((sum, c) => sum + (parseFloat(c.price * c.qty) || 0), 0);
    const customizationPrice = customizations.reduce((sum, c) => {
      const parentQty = c.qty || 1;

      // parent price
      let total = (parseFloat(c.price) || 0) * parentQty;

      // sub modifiers
      if (Array.isArray(c.subModifiers)) {
        total += c.subModifiers.reduce((subSum, s) => {
          const subQty = s.qty || 1;
          return subSum + (parseFloat(s.price) || 0) * subQty * parentQty;
        }, 0);
      }

      return sum + total;
    }, 0);

    onUpdateCart({
      item_id: item.menu_id,
      item_category_id: item.category_id,
      item_name: item.menu_item_name,
      item_image: item.menu_item_image,
      item_base_price: item.menu_item_price,
      price: (parseFloat(item.menu_item_price) + customizationPrice),
      quantity: qty,
      instructions: instructions,
      customizations
    }, item.cartItemId);
    setUpdateItem(null);
    // setSearchTerm(null)
  };
  const handleUpdateItem = (cartItem) => {
    console.log('cartItem', cartItem);
    // console.log('original menu', JSON.stringify(MenuItem, null, 2));
    let originalItem = null;

    for (const menu of MenuItem) {
      const found = menu.menu_details.find(
        menuItem => menuItem.menu_id === cartItem.item_id
      );
      if (found) {
        originalItem = found;
        break;
      }
    }
    console.log('Item being updated:', originalItem);
    console.log('Item structure:', JSON.stringify(originalItem, null, 2));
    setUpdateItem({
      ...originalItem,
      category_id: cartItem.item_category_id,
      cartItemId: cartItem.cart_item_id, // To identify which cart item to update later
      currentQuantity: cartItem.quantity,
      currentSelections: cartItem.customizations,
      currentInstructions: cartItem.instructions || ''
    });
  }
  if (cart.length === 0) {
    return (
      <div className="bg-gradient-to-r from-orange-50 to-red-50 border-t-2 border-orange-200 p-6">
        <div className="flex items-center justify-center gap-3 text-gray-400">
          <ShoppingCart className="w-6 h-6" />
          <span className="text-xl">Your cart is empty - Add some delicious items!</span>
        </div>
      </div>
    );
  }

  // if (updateItem) {
  //   return (
  //     <ItemCustomization
  //       item={updateItem}
  //       onComplete={handleCustomizationComplete}
  //       onCancel={() => setUpdateItem(null)}
  //     />
  //   )
  // }
  return (
    <>
      {/* Cart Summary Bar */}
      <div className=" bottom-0 left-0 right-0 z-50 flex items-center justify-space-between bg-addmorebg  lg:h-[180px] md:h-[100px] h-[40px]">
        {/* cancel button */}

        <div className="basis-[30%] h-full flex items-center justify-center" onClick={onCancel}>
          <Button
            size="add"
            variant="default"
            // onClick={onCheckout}
            // onClick={onCancel}
            className="p-3 text-textgray font-outfit font-medium leading-[1.2] text-center whitespace-nowrap disabled:opacity-50">
            Start Over
          </Button>
        </div>

        <div className="basis-[70%] h-full bg-boonsOrange flex items-center justify-center" onClick={() => setIsOpen(true)}>
          <Button
            variant="orange"
            // onClick={() => setIsOpen(true)}
            size="add"
            className="font-outfit font-medium leading-[1.2] text-center whitespace-nowrap disabled:opacity-50"
          >My Order ${cartTotal.toFixed(2)}
          </Button>
        </div>
      </div>
      {/* Cancel Modal */}
      {isCancel && (
        <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-8">
          <div className="bg-white max-w-3xl w-full h-fit-content p-8">
            {/* <h2 className="text-3xl font-bold mb-4">Cancel Order</h2> */}
            <div className="flex justify-center mb-3 text-[#202B49] font-outfit font-medium lg:text-[60px] md:text-[58px] xs:text-[48px] text-[36px] p-5">Are you sure ?</div>
            <div className="px-5 text-center flex justify-center text-textgray font-outfit font-normal lg:text-[36px] md:text-[34px] xs:text-[32px] text-[20px] leading-[1.2]">Cancelling this order will reset your cart and any progress you’ve made.</div>
            <div className="flex flex-row gap-10 justify-center">
              <div className="flex items-center justify-between">
                <Button
                  variant="orange"
                  onClick={() => {
                    clearCart("cart");
                    setCancelSource("cart");
                    setIsCancel(false);
                  }}
                  className="md:w-[300px] bg-boonsOrange text-white font-outfit font-medium lg:text-[50px] md:text-[48px] xs:text-[46px] text-[20px] p-2 mt-8 rounded-lg leading-[1.2] text-center"
                >
                  Yes
                </Button>
              </div>
              <div className="flex justify-center gap-2">
                <Button
                  variant="orange"
                  onClick={() => setIsCancel(false)}
                  className="md:w-[300px] bg-boonsOrange text-white font-outfit font-medium lg:text-[50px] md:text-[48px] xs:text-[46px] text-[20px] p-2 mt-8  rounded-lg leading-[1.2] text-center"
                >
                  No
                </Button>

              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cart Detail Modal */}
      <AnimatePresence onExitComplete={() => {
        // Force repaint to clear stale GPU compositing layers on kiosk WebView after zoom + close
        document.body.style.transform = 'translateZ(0)';
        requestAnimationFrame(() => { document.body.style.transform = ''; });
      }}>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/60 z-50 flex justify-end"
            onClick={() => setIsOpen(false)}
          >
            <motion.div
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-white relative h-full w-[70vw] max-w-[70vw] flex flex-col overflow-hidden"
            >
              {/* Header */}
              <div className="relative flex items-center justify-center p-2 bg-white ">

                <p className="text-[26px] lg:text-[64px] md:text-[60px] xs:text-[36px] font-outfit font-semibold flex items-center text-textcolor text-center">
                  My Order
                </p>
                {/* <p className="text-gray-600 mt-1">{cartCount} delicious items</p> */}

                <Button
                  variant="default"
                  size="back"
                  onClick={() => setIsOpen(false)}
                  className="md:w-[60px] w-[40px] md:h-[60px] h-[40px] absolute right-4 bg-[#202B49] rounded-full"
                >
                  <img src="/images/cross.png" alt="close" className="w-full h-full" />
                </Button>
              </div>
              <div className='border-b border-divider border-[2px] '></div>
              {/* Cart Items Grid */}
              <div className="flex-1 overflow-y-auto">
                <div className="flex p-4 md:p-6 bg-white">
                  <div className="flex flex-col gap-4 md:gap-6 w-full">
                    <AnimatePresence>
                      {cart.map((item, index) => (
                        <div
                          key={index}
                          className="relative flex flex-row gap-3 md:gap-4 md:pb-4 pb-2"
                        >
                          {/* Item Image */}
                          <div className="bg-white flex-shrink-0 w-auto cursor-pointer" onClick={(e) => {
                            e.stopPropagation();
                            //console.log(item);
                            handleUpdateItem(item);
                          }}>
                            <img
                              src={item.item_image}
                              alt={item.item_name}
                              className="md:w-[120px] w-[80px] aspect-square object-cover rounded-[12px] pointer-events-none"
                            />
                          </div>

                          {/* Content Wrapper */}
                          <div className="flex-1 flex flex-col min-w-0 md:ml-4 ml-2">
                            {/* Top Section: Name and Price */}
                            <div className="flex items-start justify-between md:gap-2 mb-2 cursor-pointer" onClick={(e) => {
                              e.stopPropagation();
                              console.log(item);
                              handleUpdateItem(item);
                            }}>
                              <div className="flex-1 min-w-0">
                                <p className="text-[20px] md:text-[32px] font-medium font-outfit md:font-weight-[500] text-textblack break-words">
                                  {item.item_name}
                                </p>
                              </div>
                              <div className="text-textblack font-bold font-outfit text-[18px] md:text-[32px] flex-shrink-0">
                                ${(item.price * item.quantity).toFixed(2)}
                              </div>
                            </div>

                            {/* Customizations */}
                            {item.customizations && item.customizations.length > 0 && (
                              <div className="mb-3">
                                {item.customizations.map((custom, idx) => (
                                  <div key={idx} className="mb-1">
                                    <ul className="md:ml-4 ml-3 text-[12px] md:text-[20px] lg:text-[24px] text-textgray font-outfit font-medium break-words list-disc marker:text-boonsOrange ">
                                      <li key={idx} className="break-words">
                                        {custom.qty} X {custom.name.charAt(0).toUpperCase() + custom.name.slice(1)}
                                        {/* {idx < item.customizations.length - 1 && ' , '} */}
                                        {custom.price > 0 && (
                                          <span className="text-boonsOrange">
                                            {" "}(${custom.price.toFixed(2)} )
                                          </span>
                                        )}
                                      </li>
                                    </ul>

                                    {/* SubModifiers */}
                                    {custom.subModifiers && custom.subModifiers.length > 0 && (
                                      <div className="mt-1">
                                        <div className="md:ml-4 ml-3 text-[12px] md:text-[18px] lg:text-[20px] text-textgray font-outfit font-medium">
                                          {custom.subModifiers.map((sub, subIdx) => (
                                            <div key={subIdx} className="md:ml-4 ml-2 break-words">
                                              {sub.qty} X {sub.name.charAt(0).toUpperCase() + sub.name.slice(1)}
                                              {sub.price > 0 && (
                                                <span className="ml-2 text-boonsOrange">
                                                  {" "}(${sub.price.toFixed(2)})
                                                </span>
                                              )}
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}

                            {/* Bottom Row: Remove Button (Left) and Quantity Controls (Right) */}
                            <div className="flex items-center justify-between gap-3 pt-2">
                              {/* Remove Button - Left */}
                              <button
                                onClick={() => onRemoveFromCart(item.cart_item_id)}
                                className="text-boonsOrange font-outfit font-medium text-[18px] lg:text-[32px] hover:underline flex-shrink-0"
                              >
                                Remove
                              </button>

                              {/* Quantity Controls - Right */}
                              <div className="flex items-center md:gap-4 gap-2 border md:border-[5px] border-[3px] border-boonsOrange rounded-full px-1 flex-shrink-0">
                                <motion.button
                                  whileHover={{ scale: 1.1 }}
                                  whileTap={{ scale: 0.9 }}
                                  onClick={() => onUpdateCartCount(index, item.quantity - 1)}
                                  className=" md:w-8 md:h-8 w-3 h-3 bg-white rounded-full text-black flex items-center justify-center shadow-sm"
                                >
                                  <Minus className="lg:w-8 lg:h-8 md:w-6 md:h-6 w-3 h-3 text-black font-bold" />
                                </motion.button>
                                <motion.span
                                  key={item.quantity}
                                  initial={{ scale: 1.2 }}
                                  animate={{ scale: 1 }}
                                  className="text-[15px] md:text-[32px] lg:text-[32px] font-bold min-w-[24px] text-center text-gray-800"
                                >
                                  {item.quantity}
                                </motion.span>
                                <motion.button
                                  whileHover={{ scale: 1.1 }}
                                  whileTap={{ scale: 0.9 }}
                                  onClick={() => onUpdateCartCount(index, item.quantity + 1)}
                                  className=" md:w-8 md:h-8 w-3 h-3 bg-white rounded-full text-black flex items-center justify-center shadow-sm"
                                >
                                  <Plus className="lg:w-8 lg:h-8 md:w-6 md:h-6 w-3 h-3 text-black font-bold" />
                                </motion.button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </AnimatePresence>

                  </div>

                </div>

              </div>


              {/* Footer */}
              {/* add more items */}
              <div className="flex flex-col items-center bg-white">
                <motion.button
                  size="addmore"
                  variant="addmore"
                  exit={{ x: "100%" }}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                  onClick={() => {
                    setIsOpen(false);
                  }}
                  className="w-[55%] mt-5 text-[15px] md:text-[35px] sm:text-[20px] lg:text-[45px] text-white bg-[#202b49] border md:border-[4px] border-[2px] border-bordergray rounded-full font-outfit font-regular whitespace-nowrap text-center disabled:opacity-50 mb-3 sm:mb-5 md:mb-10 p-2">
                  Add More
                </motion.button>
                <motion.button
                  size="addmore"
                  variant="addmore"
                  onClick={() => {
                    onCancel();
                  }}
                  className=" w-[55%] text-[15px] md:text-[35px] sm:text-[20px] lg:text-[45px] text-white bg-[#202b49] border md:border-[4px] border-[2px] border-bordergray rounded-full font-outfit font-regular whitespace-nowrap text-center break-words disabled:opacity-50 mb-3 md:mb-10 p-2">
                  Clear Cart
                </motion.button>
              </div>
              <div className="sticky bottom-0 w-full mt-0 bg-boonsOrange flex items-center justify-center pb-[env(safe-area-inset-bottom)]" onClick={() => {
                setIsOpen(false);
                onCheckout();
              }}>
                <Button
                  variant="orange"
                  // onClick={() => {
                  //   setIsOpen(false);
                  //   onCheckout();
                  // }}
                  size="add"
                  className="p-3 bg-boonsOrange md:h-[100px] h-[40px] lg:h-[180px] text-white  font-outfit font-medium leading-[1.2] text-center  whitespace-normal disabled:opacity-50"
                > Checkout ${cartTotal.toFixed(2)}
                </Button>
              </div>
            </motion.div >
          </motion.div >
        )
        }
      </AnimatePresence >
      {updateItem && createPortal(
        <div className="fixed inset-0 z-[10000] bg-white overflow-auto">
          <ItemCustomization
            item={updateItem}
            onComplete={handleCustomizationComplete}
            onCancel={() => setUpdateItem(null)}
          />
        </div>,
        document.body
      )}
    </>
  );
}